import HISTORY from "../actions/history/types"
import UserSocket from "../../sockets/user-socket";
import {getNewReferenceByCondition, groupByRoundId} from "../../utils/index.js";

const initialState = {
    list: [],
    selectedRoomId: null,
    selectedRoomInfo: null,
    selectedRooms: {},
    filter: {
        minBet: '',
        maxBet: '',
        result: null,
        till: null,
        type: null
    }

};
const reducer = (state = initialState, action) => {
        const socket = UserSocket.debouncedEmit.bind(UserSocket);

        switch (action?.type) {

            case HISTORY.SET_HISTORY_FILTER:
                return {
                    ...state,
                    filter: {
                        ...state.filter,
                        ...action.payload
                    }
                }

            case HISTORY.GET_HISTORY_LIST:
                socket(HISTORY.EVENT, {action: action.type, payload: action.payload, ctx: 'History'})
                return state

            case HISTORY.SET_HISTORY_LIST:
                return {
                    ...state,
                    list: action.payload.roomList
                }

            case HISTORY.SET_HISTORY_SELECTED_ROOM_ID:
                const targetRoomInfo = getNewReferenceByCondition(
                    state.list,
                    room => room?.table_history_game_id === action.payload.roomId
                );
                return {
                    ...state,
                    selectedRoomId: action.payload.roomId,
                    selectedRoomInfo: targetRoomInfo
                }

            case HISTORY.GET_HISTORY_SELECTED_ROOM_ACTIONS:
                socket(HISTORY.EVENT, {action: action.type, payload: action.payload, ctx: 'History'})
                return state

            case HISTORY.SET_HISTORY_SELECTED_ROOM_ACTIONS:
                return {
                    ...state,
                    selectedRooms: {
                        ...state.selectedRooms,
                        [action.payload.roomId]: groupByRoundId(action.payload.actions)
                    }
                }

            default:
                return state;
        }
    }
;
export default reducer;
